import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
Vue.mixin({
  data: function() {
    return {
      get SelectedPage() {
        return 'Cashflow';
      }
    }
  }
})

new Vue({
  render: function (h) { return h(App) },
}).$mount('#app')
